/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";

import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { setRegisterShop } from '../../features/register/RegisterShopSlice';
import { useDispatch } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/images/icon/calendar.svg";
import InputLabel from '@mui/material/InputLabel';
import editProfileBanner from "../../assets/images/edit-profile.png";
import CustomPopup from "../../components/popup/CustomPopup";
import { UpdateMember } from "../../services/Shop";
import dayjs from "dayjs";
import { useLiff } from 'react-liff';
import { FormControl, Select, MenuItem, FormHelperText } from "@mui/material";

export default function MemberInfoEditProfile() {

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;

    const yesterday = dayjs().subtract(1, "day");
    const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
    const [openEditedPopup, setOpenEditedPopup] = React.useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();

    const { register, setError, formState: { errors }, handleSubmit, clearErrors, control, getValues, setValue, watch } = useForm({
        defaultValues: {
            firstName: state.payload.firstName,
            lastName: state.payload.lastName,
            email: state.payload.email,
            birthDate: state.payload.birthdate,
            mobileNumber: state.payload.mobileNumber,
            gender: state.payload.gender ? state.payload.gender : '',
            age: state.payload.age,
        }
    });
    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setRegisterShop(tmpObj));
    }

    React.useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name && type) {
                fnSetData(name, value[name]);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    function isValidEmail(email) {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
    }

    const handleChangeEmail = event => {
        if (event.target.value && !isValidEmail(event.target.value)) {
            setError('email', {
                type: "email",
                message: "อีเมลไม่ถูกต้อง"
            });
        } else {
            fnSetData('email', event.target.value)
            clearErrors('email');
        }
    };

    const onSubmit = (data) => {
    };

    const onError = (data) => {
        console.log("data", data);
    };

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthdateObj = new Date(birthdate);

        if (birthdateObj > today) {
            alert('Please enter a valid birthdate.');
            return;
        }

        let calculatedAge = today.getFullYear() - birthdateObj.getFullYear();

        if (
            today.getMonth() < birthdateObj.getMonth() ||
            (today.getMonth() === birthdateObj.getMonth() &&
                today.getDate() < birthdateObj.getDate())
        ) {
            calculatedAge--;
        }

        setValue('age', calculatedAge);
    }

    async function postUpdateMember() {
        try {
            let payload = {
                lineId: lineId,
                info: {
                    firstName: getValues('firstName'),
                    lastName: getValues('lastName'),
                    email: getValues('email'),
                    birthdate: dayjs(getValues('birthDate')).add(7, 'hours'),
                    fullName: getValues('firstName') + ' ' + getValues('lastName'),
                    gender: getValues('gender'),
                    mobileNumber: getValues('mobileNumber')
                },
            }


            Object.keys(payload).forEach(key => {
                if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
                    delete payload[key];
                } else {
                    if (typeof payload[key] === 'object') {
                        Object.keys(payload[key]).forEach(key2 => {
                            if (payload[key][key2] === null || payload[key][key2] === undefined || payload[key][key2] === '') {
                                delete payload[key][key2];
                            }
                        });
                    }
                }
            });
            const { data } = await UpdateMember({ data: payload });
            if (+data["resultCode"] === 20000) {
                navigate("/member-info");
            } else {
                console.log('Error' + data["resultCode"])
            }
        } catch (error) {
            console.log("postCreateMember error", error);
        }
    }


    return (
        <>
            <form onSubmit={handleSubmit(onSubmit, onError)} noValidate autoComplete="off">
                <CustomPopup
                    title={"แก้ไขข้อมูลผู้ใช้"}
                    desc={"คุณได้แก้ไขข้อมูลผู้ใช้ของคุณ \n หากมั่นใจแล้ว กรุณากด ยืนยัน เพื่อดำเนินการต่อ"}
                    actionText={'ยืนยัน'}
                    actionFunction={() => {
                        postUpdateMember();
                        setOpenEditedPopup(false);
                    }}
                    cancelText={"ยกเลิก"}
                    cancelFunction={() => {
                        setOpenEditedPopup(false);
                    }}
                    open={openEditedPopup}
                    onClose={() => {
                        setOpenEditedPopup(false);
                    }}
                />

                <CustomPopup
                    title={"ยกเลิกแก้ไขข้อมูลผู้ใช้"}
                    desc={
                        "การแก้ไขของคุณยังไม่ถูกบันทึก \n หากต้องการยกเลิก กรุณากด ยืนยัน เพื่อดำเนินการต่อ"
                    }
                    cancelText={"ยกเลิก"}
                    cancelFunction={() => {
                        setOpenCancelPopup(false);
                    }}
                    actionText={'ยืนยัน'}
                    actionFunction={() => {
                        setOpenCancelPopup(false);
                        navigate(-1);
                    }}
                    open={openCancelPopup}
                    onClose={() => {
                        setOpenCancelPopup(false);
                    }}
                />
                <TopLogo />
                <TopBanner type="memberInfo" />
                <img src={editProfileBanner} alt="logo" style={{ width: "100%", marginTop: "-50px" }} />
                <Container maxWidth="xl">
                    <div className="bg-white px-3">
                        <div style={{ padding: "0 10px" }}>
                            <div className="flex gap-[10px] justify-start">
                                <div className="primary-color title-size">ข้อมูลส่วนตัว</div>
                                <div style={{ marginTop: "6px" }}>
                                    <p className="sub-title-size"> Personal Information</p>
                                    <div className="blue-line" ></div>
                                </div>
                            </div>


                            <div className="grid grid-cols-2 gap-2">
                                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtFirstName">ชื่อ</InputLabel>
                                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtLastName">นามสกุล</InputLabel>
                            </div>
                            <div className="grid grid-cols-2 gap-5">
                                <TextField
                                    id="txtFirstName"
                                    required
                                    fullWidth
                                    error={!!errors?.firstName}
                                    helperText={errors?.firstName?.message}
                                    {...register("firstName", { required: "กรุณากรอกชื่อ" })}
                                />

                                <TextField
                                    id="txtLastName"
                                    required
                                    fullWidth
                                    error={!!errors?.lastName}
                                    helperText={errors?.lastName?.message}
                                    {...register("lastName", { required: "กรุณากรอกนามสกุล" })}
                                />
                            </div>

                            <div className={(errors?.firstName || errors?.lastName) ? ' mt-8' : ' mt-2'}>
                                <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">เบอร์โทรศัพท์ </InputLabel>
                                <TextField
                                    id="txtMobileNumber"
                                    fullWidth
                                    required
                                    type="number"
                                    error={!!errors?.mobileNumber}
                                    helperText={errors?.mobileNumber?.message}
                                    placeholder="เบอร์โทรศัพท์ของคุณ"
                                    {...register("mobileNumber", { required: "กรุณากรอกเบอร์โทรศัพท์" })}
                                // onChange={handleChangeEmail}
                                />
                            </div>

                            <div className="grid grid-cols-2 gap-2">
                                <InputLabel required={true} className="text-header1 text-left" htmlFor="txtFirstName">เพศ</InputLabel>
                                <InputLabel required={true} className="text-header1 text-left" htmlFor="txtLastName">อายุ</InputLabel>
                            </div>
                            <div className="grid grid-cols-2 gap-5">
                                <Controller
                                    name="gender"
                                    control={control}
                                    rules={{
                                        required: "กรุณาเลือกเพศของคุณ",
                                    }}
                                    render={({ field }) => (
                                        <FormControl fullWidth>
                                            <Select
                                                {...field}
                                                // onChange={handleChange}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Without label' }}
                                            >
                                                <MenuItem value="" selected disabled style={{ color: "#B7B7B7" }}>
                                                    <p style={{ color: "#B7B7B7" }}>เพศของคุณ</p>
                                                </MenuItem>
                                                <MenuItem value={1}>ชาย</MenuItem>
                                                <MenuItem value={2}>หญิง</MenuItem>
                                            </Select>
                                            <FormHelperText>Without label</FormHelperText>
                                        </FormControl>
                                    )}
                                />

                                <TextField
                                    id="txtLastName"
                                    fullWidth
                                    disabled
                                    {...register("age")}
                                />
                            </div>


                            <div className={errors?.mobileNumber ? ' mt-8' : ' mt-2'}>
                                <InputLabel className="text-header1 text-left" htmlFor="txtEmail">อีเมล </InputLabel>
                                <TextField
                                    id="txtEmail"
                                    fullWidth
                                    error={!!errors?.email}
                                    helperText={errors?.email?.message}
                                    placeholder="อีเมลของคุณ"
                                    {...register("email", {
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "อีเมลไม่ถูกต้อง"
                                        }
                                    })
                                    }
                                    onChange={handleChangeEmail}
                                />
                            </div>

                            <div className={errors?.email ? 'relative mt-8' : 'relative mt-2'}>
                                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">วัน/เดือน/ปี ที่เกิด </InputLabel>
                                <Controller
                                    name="birthDate"
                                    control={control}
                                    rules={{
                                        required: "กรุณาเลือกวัน/เดือน/ปีที่เกิด",
                                    }}
                                    render={({ field }) => (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <MobileDatePicker
                                                {...field}
                                                className="w-full"
                                                inputFormat="DD/MM/YYYY"
                                                value={field.value ? dayjs(field.value) : null}
                                                maxDate={yesterday}
                                                name="birthDate"
                                                onChange={(date) => {
                                                    field.onChange(date)
                                                    calculateAge(date)
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        name="birthDate"
                                                        {...params}
                                                        error={!!errors?.birthDate}
                                                        helperText={errors?.birthDate?.message}
                                                        placeholder="วัน / เดือน / ปี"
                                                    />
                                                )}
                                            />
                                            <img
                                                className={
                                                    `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                                                    (!!errors?.birthDate
                                                        ? "bottom-[42px]"
                                                        : null)
                                                }
                                                src={calendar}
                                                alt=""
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </div>
                            <br></br>

                        </div>
                    </div>
                </Container>
                <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
                    <Stack
                        spacing={2}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => setOpenCancelPopup(true)}>
                            ยกเลิก
                        </SecondaryButton>
                        <PrimaryButton variant="contained" className="w-[40%]" onClick={() => setOpenEditedPopup(true)}>
                            บันทึก
                        </PrimaryButton>
                    </Stack>
                </div>
            </form>
        </>
    );
}
